module.exports = {
      id: "profile-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#profile-usage",
      toString: function () {
        return this.url;
      }
    }